<div class="heading">
    <p *ngIf="userData?.active">Deactivate User</p>
    <p  *ngIf="!userData?.active">Activate User</p>
</div>
<div class="instruction">
    <p class="mb-32" *ngIf="userData?.active" style="color: #0F1A2E;">Are you sure you want to Deactivate '{{userData?.username}}'? Once Deactivated, they will no longer have access to the application.</p>
    <p class="mb-32" *ngIf="!userData?.active" style="color: #0F1A2E;">Are you sure you want to activate '{{userData?.username}}'? Once activated, they will regain access to the application.</p>
</div>
<div class="btn-container">
    <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" class="w-50 mr-12" (click)="cancelActiveInactivateModel()"></app-button>
    <app-button [type]="'primary'" *ngIf="userData?.active" [buttonType]="'button'" [buttonText]="'Deactivate'" class="w-50" (click)="activeInactivateModel()"></app-button>
    <app-button [type]="'primary'"  *ngIf="!userData?.active" [buttonType]="'button'" [buttonText]="'Activate'" class="w-50" (click)="activeInactivateModel()"></app-button>
</div>